export default [
  { text: 'colors', url: '/ '},
  { text: 'faq', url: '/faq'},
  { text: 'contribute', url: '/contribute'}
];
